
import Vue from 'vue'
import { defaultDescription } from '@/seo'

export default Vue.extend({
  seo: {
    title: 'Page Not Found | Aaron Cunliffe',
    description: defaultDescription,
    robots: 'noindex'
  }
})
